import { CloseOutlined } from "@ant-design/icons";
import { AddFilter, FilterItem } from "@/controls";
import { Button, Form } from "antd";
import { useState, useEffect } from "react";
import TriStateCheckbox from "../../controls/tri-state-checkbox";
import { storeDocVids } from "../../extensions/helper";

const StockFilter = ({ items = [], value, onClose }) => {
  const emptyFilter = { Active: null };
  const [tempFilter, setTempFilter] = useState(value ?? emptyFilter);
  const [addingFilter, setAddingFilter] = useState(false);

  useEffect(() => {
    setTempFilter(value ?? emptyFilter);
  }, [value]);

  const getUniqueClientOptions = (idField, nameField) => {
    const map = new Map();
    items.forEach(item => {
      const id = item[idField];
      const name = item[nameField];
      if (id && name) {
        map.set(id, name);
      }
    });
    return Array.from(map, ([value, label]) => ({ value, label }));
  };

  const filterOptions = [
    { type: "clientOutIds", label: "Отправитель", tooltip: "Отправитель", inputType: "multiselect", options: getUniqueClientOptions("clientOutId", "clientOutName") },
    { type: "clientInIds", label: "Получатель", tooltip: "Получатель", inputType: "multiselect", options: getUniqueClientOptions("clientInId", "clientInName") },
    { type: "documentVidIds", label: "Вид документа", tooltip: "По виду документа", inputType: "multiselect", options: storeDocVids, width: 250 },
  ];

  const filterLabels = {
    clientOutIds: "Отправитель",
    clientInIds: "Получатель",
    documentVidIds: "Вид документа",
  };

  const renderFilterItem = (key, data) => {
    const staticOption = filterOptions.find(f => f.type === key); // Опции из текущих items
    const savedOptions = data.options || []; // Опции, которые пришли в value

    const combinedOptions = Array.from(new Map([...savedOptions, ...(staticOption?.options || [])].map(obj => [obj.value, obj])).values());
    
    return (
      <Form.Item key={key} label={filterLabels[key] || key} style={{ width: "100%" }}>
        <FilterItem key={key} type={staticOption?.inputType} value={data.value} options={combinedOptions}
          onChange={(val) => onFilterChange({ [key]: val })}
          onRemove={() => {
            const { [key]: _, ...rest } = tempFilter;
            setTempFilter(rest);
          }}
        />
      </Form.Item>
    );
  };

  const filters = Object.entries(tempFilter)
    .filter(([key]) => !["dateFrom", "dateTo", "Active"].includes(key))
    .map(([type, value]) => ({ type, ...value }));

  const onFilterChange = (changedValues) => {
    setTempFilter(prev => {
      const next = { ...prev };
      Object.keys(changedValues).forEach(key => {
        if (prev[key] && typeof prev[key] === 'object' && 'value' in prev[key]) {
          next[key] = { ...prev[key], value: changedValues[key] };
        } else {
          next[key] = changedValues[key];
        }
      });
      return next;
    });
  };

  const handleAddTopFilter = (type) => {
    if (tempFilter[type]) return;
    const option = filterOptions.find(opt => opt.type === type);
    const inputType = option?.inputType;
    let initialValue = undefined;
    let options = option?.options;
    onFilterChange({ [type]: { value: initialValue, inputType, options }});
    setAddingFilter(false);
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }} />
          </div>
          <div className="stock-filter-container">
            {filters.length === 0 && !addingFilter && (
              <AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter} />
            )}
            {filters.map((f) => renderFilterItem(f.type, f))}
            {filters.length < filterOptions.length && (
              addingFilter ? (
                <AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter} />
              ) : (
                filters.length !== 0 && (
                  <Button onClick={() => setAddingFilter(true)} type="dashed" className="filter-add-button">+</Button>
                )
              )
            )}
            <TriStateCheckbox name="Active" value={tempFilter.Active} onChange={(val) => onFilterChange({ Active: val })}>
              Активный
            </TriStateCheckbox>
            <Button onClick={() => onClose(tempFilter)}>ОК</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockFilter;